import { checkAxiosResponse } from '@mst-fe/shared';
import axios from 'axios';

import { axiosOptions } from '../../services/requests';

export class AuthorisationApi {
  async generateApiKey(expirationSeconds: number): Promise<string | undefined> {
    return (
      await checkAxiosResponse(
        axios.post<{ apiKey: string }>('/api/authorization/generate-api-key', { expirationSeconds }, axiosOptions()),
        {
          errorMessage: 'Error generating API key',
        }
      )
    )?.apiKey;
  }
}
